import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import Sidebar from './Sidebar';
import Chat from './Chat';
import {login, selectUser,logout} from './features/userSlice';
import Login from './Login';
import {auth} from './firebase';

function App() {
  const user=useSelector(selectUser);
  const dispatch=useDispatch();

  useEffect(()=>{
    auth.onAuthStateChanged((authUser)=>{
      console.log("user is ",authUser)
      if(authUser){
        dispatch(login({
          uid: authUser.uid,
          photo:authUser.photoURL,
          email: authUser.email,
          displayName:authUser.displayName,
        }));
      }
      else{
        dispatch(logout()
        );

      }
    })
  },[dispatch])
  return (
    <div className="App">
    {user?(
      <>
    <Sidebar/>
    <Chat/>
      </>
    ):
    (
      <Login/>
    )}

    </div>
  );
}

export default App;
